// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"a0b5cae9","791":"3026762b","989":"382e7b5c"}[chunkId] + ".chunk.css";
};